/* import __COLOCATED_TEMPLATE__ from './select-method.hbs'; */
import TwoFactorUpgradeSelectMethodComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/upgrade/select-method';
export default class TwoFactorModalUpgradeSelectMethodComponent extends TwoFactorUpgradeSelectMethodComponent {
  constructor() {
    super(...arguments);
  }
}